import { FlowDefinition } from '../types';
import { generatedFlows } from './generatedFlows';
import { contactFlowsV2 } from './contactFlowsV2';

export const initialFlows: FlowDefinition[] = [
  ...contactFlowsV2,
  ...generatedFlows
];
